import BetPanel from './BetPanel.jsx';

export default BetPanel;



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/index.js